import z from 'zod';
import { endpoints } from '@/api/endpoints';
import { getEmbeddedPartnersResponseSchema, getProductTiersResponseSchema } from '@/api/simulate/schemas';
import { apiRequestWithoutSuffix } from '@/api/utils/api';
import type { Country } from '@/constants/config';

export const generateAuthTokenWithNationalNumber = ({
  country,
  nationalNumber,
}: {
  country: Country;
  nationalNumber: string;
}) =>
  apiRequestWithoutSuffix({
    url: endpoints.simulate.user.generateToken,
    method: 'POST',
    schema: z.object({ authToken: z.string() }),
    data: { country, nationalNumber },
  });

export const getProductTiers = (channelProviderId: string) =>
  apiRequestWithoutSuffix({
    url: endpoints.simulate.productTiers,
    method: 'GET',
    schema: getProductTiersResponseSchema,
    params: {
      channelProviderId,
    },
  });

export const getEmbeddedPartners = (country: Country) =>
  apiRequestWithoutSuffix({
    url: endpoints.simulate.embeddedPartners(country),
    method: 'GET',
    schema: getEmbeddedPartnersResponseSchema,
  });

export const createBusinessUser = ({
  country,
  embeddedPartner,
  business,
  guarantor,
}: {
  country: Country;
  embeddedPartner: {
    name: string;
  };
  business: {
    providerId: string;
    name?: string;
    creditLimit: number;
    annualInterestRate: number;
  };
  guarantor: {
    nationalNumber: string;
    email: string;
    mobile?: string;
    firstName?: string;
    givenName?: string;
    lastName?: string;
    country?: string;
    dateOfBirth?: string;
  };
}) =>
  apiRequestWithoutSuffix<void>({
    url: endpoints.simulate.createBusiness(country),
    method: 'POST',
    data: {
      embeddedPartner,
      business,
      guarantor,
    },
  });
